import {
    Alert as MuiAlert,
    AlertProps as MuiAlertProps,
    alpha,
    styled,
} from "@mui/material";

interface AlertExtraProps {
    compact?: boolean;
}

export type AlertProps = MuiAlertProps & AlertExtraProps;

export const Alert = styled(MuiAlert, {
    shouldForwardProp: (prop) => prop !== "compact",
})<AlertExtraProps>(({ theme, severity = "info", compact }) => {
    const colorMap = {
        error: {
            background: "#fef2f2",
            border: theme.palette.error.main,
            icon: theme.palette.error.main,
        },
        warning: {
            background: "#fef3c7",
            border: "#92400e",
            icon: "#92400e",
        },
        info: {
            background: alpha(theme.palette.info.main, 0.06),
            border: theme.palette.info.main,
            icon: theme.palette.info.main,
        },
        success: {
            background: "#E7F5E9",
            border: theme.palette.success.main,
            icon: theme.palette.success.main,
        },
    };

    const colors = colorMap[severity] ?? colorMap.info;

    return {
        backgroundColor: colors.background,
        border: "none",
        borderLeft: `3px solid ${colors.border}`,
        borderRadius: "8px",
        color: theme.palette.text.primary,
        fontSize: "0.8125rem",
        fontWeight: 500,
        padding: compact ? "6px 12px" : "8px 12px",
        alignItems: "center",
        "& .MuiAlert-icon": {
            color: colors.icon,
            marginRight: theme.spacing(1),
            padding: 0,
            opacity: 1,
            fontSize: "1.25rem",
        },
        "& .MuiAlert-message": {
            padding: 0,
            lineHeight: compact ? 1.4 : 1.5,
        },
    };
});
